<template>
  <div class="progress">
    <div v-bind="$attrs" class="progress-container md:md-progress-container">
      Page {{ $attrs.current }} of {{ $attrs.total }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
};
</script>

<style>
.progress {
  bottom: 1vh;
  left: 0;
  position: absolute;
  width: 100%;
}

.progress-container {
  background-color: #5e5b5c;
  border-radius: 5rem;
  color: white;
  font-size: 1rem;
  margin: auto;
  padding: .25em 1.75em;
  text-align: center;
  width: fit-content;
}

@responsive {
  .md-progress-container {
    font-size: 0.81em;
  }
}
</style>
